import { authService } from '../auth/auth.service';
import config from '../config/config';
import endpoint from '../util/endpoint';
import { awaitStoreGuid } from '@/lib/awaitStoreGuid';
import { service } from '@whiz-cart/node-shared/service/service';
import { urlService } from '@whiz-cart/ui-shared/url/url.service';

class PingService {
    handles: (() => void)[] = [];

    async start() {
        this.stop();

        const { pingInterval = 15 * 60 * 1000 } = config as {
            pingInterval?: number;
        };

        const timer = setInterval(this.sendNoParams, pingInterval);
        this.handles.push(() => clearInterval(timer));

        this.handles.push(
            urlService.state
                .map((url) => url.params?.storeGuid)
                .subscribe((storeGuid, previousStoreGuid) => {
                    this.send(storeGuid, previousStoreGuid);
                }),
        );

        this.handles.push(authService.loginState.map((state) => state.isLoggedIn).subscribe(this.sendNoParams));

        window.addEventListener('focus', this.sendNoParams);
        this.handles.push(() => window.removeEventListener('focus', this.sendNoParams));
    }

    stop() {
        for (const handle of this.handles) {
            handle();
        }
        this.handles = [];
    }

    sendNoParams = () => {
        void this.send();
    };

    send = async (storeGuid?: string, previousStoreGuid?: string) => {
        const { isLoggedIn } = authService.loginState.get();
        if (!isLoggedIn) return;

        if (!storeGuid) storeGuid = await awaitStoreGuid();
        try {
            await endpoint('storeManager.ping').post({ storeGuid, previousStoreGuid });
            console.debug('Sent ping', [previousStoreGuid, storeGuid].join(' -> '));
        } catch (e) {
            console.warn('Failed to send ping:', e);
        }
    };
}

export default service('pingService', PingService);
